import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h1>Page Not Pound 404!!!</h1>
        </div>
    );
};

export default NoMatch;